
// import SuccessIcon from "../../../assets/images/icons/check-circle.png"
// import ErrorIcon from "../../../assets/images/icons/x-circle.png"
import "./index.scss"
export const AlertMsg = ({ type, message, toast }: any) => {
    return (
        <div className={`alert-msg ${type}${toast ? " toast-alert" : ""}`} role={toast ? "status" : undefined}>

            {/* {type === "success" &&
                <img className="alert-icon" src={SuccessIcon} alt="" />
            }
            {type === "error" &&
                <img className="alert-icon" src={ErrorIcon} alt="" />
            } */}

            {type === "error" &&
                <div className="alert-txt">{message || "An Error Occurred"} </div>
            }
            {type === "success" &&
                <div className="alert-txt">{message || "Successful"} </div>
            }

        </div>
    )
}
